import React from "react";
import NumberMath from "../../components/ClassTwo/NumberMath"; // Correctly import the NumberMath component
import NumberMathMenu from "./NumberMath"; // Ensure this is properly typed as well
import EnvironmentScience from "../../components/ClassTwo/EnvironmentScience";
import EnvironmentScienceMenu from "./EnvironmentScience";
import EnglishMenu from "./English";
import English from "../../components/ClassTwo/English";
import ComputerStudies from "../../components/ClassTwo/ComputerStudies";
import ComputerMenu from "./ComputerStudies";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

// Define ClassTwoMenu with the proper type
const ClassTwoMenu: MenuItem[] = [
    { 
        url: "/class-two/number-math", 
        title: "Mathematics", 
        component: NumberMath, 
        subMenu: NumberMathMenu // Ensure NumberMathMenu is typed as MenuItem[]
    },
    { 
        url: "/class-two/english", 
        title: "English", 
        component: English, // Replace with the correct component if applicable
        subMenu: EnglishMenu
    },
    { 
        url: "/class-two/environmental-science", 
        title: "Environmental Science", 
        component: EnvironmentScience, // Replace with the correct component if applicable
        subMenu: EnvironmentScienceMenu
    },
    { 
        url: "/class-two/computer-studies", 
        title: "Computer Studies", 
        component: ComputerStudies, // Replace with the correct component if applicable
        subMenu: ComputerMenu 
    }
];

export default ClassTwoMenu;

